import { Taskable } from './taskable';
export class TaskGroup extends Taskable {}